<div class="{{ backgroundColor() }} rounded p-4 flex flex-col gap-4">
  <div class="flex items-center gap-x-2">
    <parkour-icon class="text-n-600" [name]="icon()" />

    <h2 class="typo-h5">{{ title() }}</h2>
  </div>
  <ng-content />
</div>
